<template>
  <div v-loading="loading">
    <el-card>
      <condition-search :query-items="queryItems" :search-param="queryParams" @search="search" @reset="reset" />
    </el-card>
    <el-card>
      <div class="mb-2">
        <el-alert show-icon title="以下产品UDI码被跨地区扫码，可能存在窜货的情况" type="warning" :closable="false">
        </el-alert>
      </div>
      <el-table  :height="heightStyleObj" :data="listData" style="width: 100%" highlight-current-row border stripe>
        <template slot="empty">
          <el-empty description="暂无数据"></el-empty>
        </template>
        <el-table-column prop="completeCode" label="产品UDI码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productName" label="产品名称" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="area" label="出库地区" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row | formatArea }}
          </template>
        </el-table-column>
        <el-table-column prop="scanArea" label="扫码地区" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ `${scope.row.provinceName}${scope.row.cityName}${scope.row.countyName}` }}
          </template>
        </el-table-column>
        <el-table-column prop="scanTime" label="扫码时间" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.scanTime ? parseTime(scope.row.scanTime) : null }}
          </template>
        </el-table-column>
        <el-table-column prop="handleStatus" label="状态" width="120">
          <template slot-scope="scope">
            <dict-tag :options="dictObj.handle_status" :value="scope.row.handleStatus" />
          </template>
        </el-table-column>
        <el-table-column prop="created" label="操作" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handlePreview(row)">查看</el-button>
            <el-button v-if="row.handleStatus === 'unhandle'" type="text" @click="handleDeal(row)">处理</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination v-show="queryParams.total > 0" class="flex justify-end" :total="queryParams.total"
        :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList" />
    </el-card>
    <addOrUpdate v-if="dealShow" :visible="dealShow" :dict-obj="dictObj" :flee-warning-info="fleeWarningInfo" @close="close">
    </addOrUpdate>
    <Detail v-if="detailVisible" :visible="detailVisible" :dict-obj="dictObj" :flee-warning-info="fleeWarningInfo" @close="close"/>
  </div>
</template>

<script>
import { getFleeWarningList } from '@/api/antiFake/fleeWarning'
import { getDict } from '@/api/common'
import { regionData } from 'element-china-area-data'
import { findNode } from '@/utils/ruoyi'
import addOrUpdate from './components/addOrEdit'
import Detail from './components/detail'

export default {
  components: { addOrUpdate,Detail },
  filters:{
    formatArea(value){
      if(value){
        const {deliveryProvinceName='',deliveryCityName='',deliveryCountyName=''} = value
        return `${deliveryProvinceName}${deliveryCityName}${deliveryCountyName}`
      }
      return ''
    }
  },
  data() {
    return {
      queryItems: [
        {
          label: '关键字搜索',
          field: 'searchValue',
          placeholder: '产品名称/UDI码',
          width: '300px',
          type: 'input'
        },
        {
          label: '扫码时间',
          field: 'dateTime',
          type: 'date'
        },
        {
          label: '状态',
          field: 'roleType',
          type: 'select',
          options: []
        },
        {
          label: '出库扫码区域',
          field: 'area',
          type: 'cascader',
          options: regionData
        },
      ],
      regionData,
      queryParams: { // 查询参数
        pageNum: 1,
        pageSize: 10,
        total: 0,
        searchValue: null,
        area: [],
        dateTime: []
      },
      dictObj: {
        handle_status: [],
        handle_way: []
      },
      listData: [],
      fleeWarningInfo:{},
      loading: false,
      dealShow: false,
      detailVisible:false
    }
  },
  created() {
    this.heightStyleObj = window.innerHeight - 405 + 'px'
    this.getList()
    this.getDicts(['handle_status', 'handle_way'])

  },
  methods: {
    reset() {
      this.queryParams = Object.assign(this.$data.queryParams, this.$options.data.call(this)).queryParams
      this.search()
    },
    search() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
          if (dictType === 'handle_status') {
            const findIndex = this.queryItems.findIndex(item => item.field === 'roleType')
            this.queryItems[findIndex].options = JSON.parse(JSON.stringify(res.rows))
          }
        })
      })
    },
    getList() {
      const queryParams = JSON.parse(JSON.stringify(this.queryParams))
      if (queryParams.dateTime) {
        const [scanTimeBegin, scanTimeEnd] = queryParams.dateTime
        queryParams.scanTimeBegin = scanTimeBegin
        queryParams.scanTimeEnd = scanTimeEnd
        delete queryParams.dateTime
      }
      if (queryParams.area) {
        // 省市区转换
        const [consigneeProvinceName, consigneeCityName, consigneeCountyName] = queryParams.area
        // 省市区转换
        const provinceName = findNode(this.regionData, consigneeProvinceName)
        const cityName = findNode(this.regionData, consigneeCityName)
        const countyName = findNode(this.regionData, consigneeCountyName)
        queryParams.provinceName = provinceName ? provinceName.label : ''
        queryParams.cityName = cityName ? cityName.label : ''
        queryParams.countyName = countyName ? countyName.label : ''
        delete queryParams.area
      }
      this.loading = true
      getFleeWarningList(queryParams).then((res) => {
        this.listData = res.rows
        this.queryParams.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    // 处理
    handleDeal(row) {
      this.fleeWarningInfo = JSON.parse(JSON.stringify(row))
      this.dealShow = true
    },
    // 查看
    handlePreview(row) {
      this.fleeWarningInfo = JSON.parse(JSON.stringify(row))
      this.detailVisible = true

    },
    // 关闭弹窗
    close() {
      this.dealShow = false
      this.detailVisible = false
      this.fleeWarningInfo = {}
      this.getList()
    }
  }
}
</script>
